import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import Exporting from "highcharts/modules/exporting.js";
import Sunburst from "highcharts/modules/sunburst.js";
import { Typography } from "@mui/material";

Exporting(Highcharts);
Sunburst(Highcharts);

class SunburstChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      root: this.props.region,
      clickedValue:
        this.props.data && this.props.data.length > 0
          ? this.props.data[0].totals
          : [],
    };
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    const chart = this.chartRef.current.chart;
    this.series = chart.series[0]; // Store reference to series
    this.props.data && this.props.data.length > 0
      ? this.setState({
          clickedValue: this.props.data[0].totals[this.props.region],
        })
      : this.setState({ clickedValue: [] });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.props.data && this.props.data.length > 0
        ? this.setState({
            clickedValue: this.props.data[0].totals[this.props.region],
          })
        : this.setState({ clickedValue: [] });
    }
  }

  handleClick = (series, event) => {
    this.series.onClickDrillToNode({
      point: event.point,
    });
    const clickedValue =
      (Object.keys(this.props.data[0].totals).includes(event.point.name) &&
        (event.point.value === this.state.clickedValue
          ? this.props.data[0].totals[this.props.region]
          : event.point.value)) ||
      this.state.clickedValue;
    this.setState({ clickedValue });
  };

  render() {
    let subgroup = this.props.subgroup;
    let data = this.props.data;
    let totals = data && data.length > 0 ? data[0].totals : [];
    const defaultOptions = {
      chart: {
        animation: false,
        backgroundColor: "transparent",
        height: 670,
        width: 800,
        spacingTop: 0,
      },
      exporting: false,
      title: null,
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormatter: function() {
          let percentage =
            (this.value / this.series.userOptions.clickedValue) * 100;
          return (
            "<b>" +
            this.name +
            "</b><br/>" +
            "Subgroup: " +
            subgroup +
            "<br/>" +
            "Number of students: " +
            this.value +
            "<br/>" +
            "Percentage: " +
            percentage.toFixed(2) +
            "%"
          );
        },
      },
      series: [
        {
          type: "sunburst",
          data: data,
          name: "Root",
          allowDrilldown: true,
          allowDrilldownToNode: true,
          stickyTracking: false,
          allowTraversingTree: false,
          cursor: "pointer",
          point: {
            events: {
              click: (event) => this.handleClick(this.series, event),
            },
          },
          dataLabels: {
            distance: 30,
            connectorWidth: 1,
            connectorColor: "black",
            style: {
              textOutline: "none",
              fontWeight: "normal",
              color: "white",
            },
            formatter: function() {
              return this.point.name;
            },
          },
          levels: [
            {
              level: 1,
              levelIsConstant: false,
              dataLabels: {
                filter: {
                  property: "outerArcLength",
                  operator: ">",
                  value: 64,
                },
              },
            },
            {
              level: 2,
              colorByPoint: true,
            },
            {
              level: 3,
              colorVariation: {
                key: "brightness",
                to: -0.5,
              },
            },
            {
              level: 4,
              colorVariation: {
                key: "brightness",
                to: 0.5,
              },
            },
          ],
        },
      ],
    };
    Highcharts.setOptions(this.props.containerId, {});
    let newDefaultOptions = { ...defaultOptions };
    return (
      <div id={this.props.containerId}>
        <Typography
          variant="inherit"
          className="form-metrics-header"
          style={{
            margin: "20px auto",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          {this.props.title}
        </Typography>
        {this.props.remainingOptions ? (
          <HighchartsReact
            ref={this.chartRef}
            options={{
              ...newDefaultOptions,
              ...this.props.remainingOptions,
              series: [
                {
                  ...newDefaultOptions.series[0],
                  clickedValue: this.state.clickedValue,
                },
              ],
            }}
            highcharts={Highcharts}
          />
        ) : (
          <h1>...loading...</h1>
        )}
      </div>
    );
  }
}

export default SunburstChart;
